import {
  configureStore as createStore,
  combineReducers,
} from '@reduxjs/toolkit';
import { domainRegistry } from './domainRegistry';
import type { DomainConfig, StoreConfig } from './types';
import { unauthorizedMiddleware } from '../infrastructure/http/unauthorizedMiddleware';
import { setUnauthorizedHandler } from '../infrastructure/http/apiClient';
import { logOut } from '../reducers/authorization-slice';
import { paths } from '../routes/paths';

export const configureStore = (config?: Partial<StoreConfig>) => {
  const domains = config?.domains || domainRegistry;

  const reducers = domains.reduce<Record<string, DomainConfig['reducer']>>(
    (acc, domain) => {
      acc[domain.name] = domain.reducer;
      return acc;
    },
    {},
  );

  const middlewareList = domains
    .filter((domain) => domain.middleware && domain.middleware.length > 0)
    .flatMap((domain) => domain.middleware || []);

  const store = createStore({
    reducer: combineReducers(reducers),
    preloadedState: config?.preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(middlewareList, unauthorizedMiddleware),
  });

  setUnauthorizedHandler(() => {
    const token = store.getState().authorization?.accessToken;
    if (!token) {
      return;
    }
    store.dispatch(logOut());
    if (
      typeof window !== 'undefined' &&
      !window.location.pathname.startsWith('/auth')
    ) {
      window.location.assign(paths.signIn);
    }
  });

  return store;
};
